<div appNavBreadcrumb *transloco="let t">
  <app-breadcrumb-item [title]="t('sb-strategy-form.new_sb_strategy')" />
</div>
<div>
  <app-sb-strategy-form />
</div>
